import React, { useEffect, useRef, useState } from 'react';
import config from '../config';
import { vehicleHighlights, vehicleFocusPoints } from '../data/content';
import Reveal from './Reveal';
import EquipmentChecklist from './EquipmentChecklist';
import vehicleVideo from '../assets/videos/Folkmar1.mp4';
import './Vehicle.css';

/** Sekcia vozidla: video v slučke, stručné zhrnutie, štyri krátke bloky
 *  výbavy a odkaz na kompletný zoznam (rozbaľovací) aj na galériu.
 *  Video sa načíta až keď sa sekcia priblíži k obrazovke (súbor je veľký). */
export default function Vehicle() {
  const figureRef = useRef(null);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    const target = figureRef.current;
    if (!target || !('IntersectionObserver' in window)) {
      setShowVideo(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowVideo(true);
          observer.disconnect();
        }
      },
      { rootMargin: '400px 0px' } // začni sťahovať s predstihom pred doscrollovaním
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="section" id="vozidlo">
      <div className="container">
        <Reveal className="section-heading">
          <span className="eyebrow">Vozidlo</span>
          <h2>{config.vehicleName}</h2>
          <p className="lead">
            Štyria sa v nej pohodlne odvezú aj vyspia. Automatická prevodovka
            spríjemní dlhšie cesty a kompaktné rozmery uľahčia parkovanie aj
            presuny po mestách.
          </p>
        </Reveal>

        <Reveal>
          <figure className="vehicle__photo" ref={figureRef}>
            {showVideo && (
              <video
                src={vehicleVideo}
                autoPlay
                loop
                muted
                playsInline
                disablePictureInPicture
                preload="metadata"
                aria-label={`${config.vehicleName} v prírode – video bez zvuku`}
              />
            )}
          </figure>
        </Reveal>

        <ul className="vehicle__highlights" aria-label="Zhrnutie vozidla">
          {vehicleHighlights.map((label, index) => (
            <Reveal key={label} delay={Math.min(index * 0.04, 0.3)}>
              <li className="vehicle__highlight">{label}</li>
            </Reveal>
          ))}
        </ul>

        <Reveal className="section-heading vehicle__focus-heading">
          <h3>Všetko potrebné máš poruke</h3>
        </Reveal>

        <div className="vehicle__focus">
          {vehicleFocusPoints.map((point, index) => (
            <Reveal key={point.title} delay={Math.min(index * 0.06, 0.3)}>
              <div className="vehicle__focus-item">
                <h4>{point.title}</h4>
                <p>{point.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <EquipmentChecklist label="Pozrieť kompletnú výbavu" />
        </Reveal>


      </div>
    </section>
  );
}
